export enum APIStatus {
  idle = 'idle',
  pending = 'pending',
  rejected = 'rejected',
  fulfilled = 'fulfilled',
}
